import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import windbreaker from "../../Assets/Projects/WindBreaker.png";
import vaw from "../../Assets/Projects/VAWLogo.png";
import XRHouse from "../../Assets/Projects/Carbon Emission.png";
import XRRace from "../../Assets/Projects/XR Race.png";
import MachinaRebellion from "../../Assets/Projects/MachinaRebellion.jpg"
import RunningVR from "../../Assets/Projects/RunningVR.png"
import FeridAroundTheWorld from "../../Assets/Projects/FeridAroundTheWorld.jpg"
import WordLinkBattles from "../../Assets/Projects/WordLinkBattles.jpg"
function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vaw}
              videoPath= "https://storage.googleapis.com/creatorspace-public/users%2Fclqfe4p8t00fbq1018lrqxle8%2FaR8Gt9gYac1AoAFs-movie_006.mp4"
              isVideo={false}
              isBlog={false}
              title="Virtual Adventure Workout"
              description="Step into a new era with our VR health system. It integrates virtual reality for precision in patient care, with intuitive interfaces and real-time insights."
              ghLink="https://www.vaw.training/"
            />
          </Col>


           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={windbreaker}
              isBlog={true}
              title="WindBreaker"
              description="While gameplay elements may vary across levels, the metrics we collect remain consistent. This ensures continuity in tracking the player's performance and allows for comprehensive analysis regardless of the specific challenges presented in each level."
              ghLink="https://drive.google.com/file/d/1rBJrhw72z39uMLSwWaTzHvXvs2w2PIVl/view?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={XRHouse}
              isBlog={true}
              title="House Appliance MR Game"
              description="A VR Project for a client that needs a simulation for energy consumption in his house."
              ghLink="https://drive.google.com/file/d/1e8qoiNaWa6vOWkntCr7J1FRybzoB5nJ1/view?usp=sharing"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={RunningVR}
              isBlog={true}
              title="VAW Running"
              description="The Second VR Game For VAW"
              ghLink="https://drive.google.com/file/d/1TcIcJOBdBWI9yKVs5X3l5pD-dzUoG6ZK/view?usp=sharing"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={XRRace}
              isBlog={true}
              title="MR Racing"
              description="A demo for a client that needs a simulation for energy consumption using Car."
              ghLink="https://drive.google.com/file/d/16P-jUC_rFAQEGrzMNjppiAZLaorzvni0/view?usp=sharing"
            />
          </Col>

        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={MachinaRebellion}
              isBlog={true}
              title="Machina Rebellion"
              description="A bullet heaven game I worked on with a friend of mine."
              ghLink="https://www.youtube.com/watch?v=2rYH_8sd2NU"
            />
          </Col>

        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={WordLinkBattles}
              isBlog={true}
              title="WordLink : Battle"
              description="A cross words game where you fight your enemies by guessing words"
              ghLink="https://play.google.com/store/apps/details?id=com.UnityTechnologies.com.unity.template.CrossWordsRPG&hl=en"
            />
          </Col>
          
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={FeridAroundTheWorld}
              isBlog={true}
              title="Ferid Around The World"
              description="An education platform for kids "
              ghLink="https://play.google.com/store/apps/details?id=com.Horizon.FaridAroundTheWorld&hl=en"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
